import React from "react";
import { DateTime } from "luxon";
import { CustomerTypes } from "constants/enums";
import { ClearLabel } from "components/controls";
import { FieldNames } from "./JobsFilters";

const FieldMappings = {
  [FieldNames.CustomerTypes]: "Customer Type",
  [FieldNames.DepartmentDisplay]: "Department",
  [FieldNames.CompletedDateFrom]: "Completed Date From",
  [FieldNames.CompletedDateTo]: "Completed Date To",
  [FieldNames.ContractManagerDisplay]: "Contract Manager",
};

const FormatDisplay = (item) => {
  let value = item.value;
  switch (item.label) {
    case FieldNames.CustomerTypes:
      value = item.value.map((x) => CustomerTypes[x]).join(", ");
      break;
    case FieldNames.CompletedDateFrom:
    case FieldNames.CompletedDateTo:
      value = DateTime.fromISO(item.value).toFormat("dd MMM yyyy");
  }

  return `${FieldMappings[item.label] || item.label}: ${value}`;
};

const JobsFilterDisplay = ({ filters, resetFilters }) => {
  const items = filters
    ? Object.keys(filters)
        .filter(
          (f) =>
            f !== FieldNames.Search &&
            f !== FieldNames.Department &&
            f !== FieldNames.ContractManager &&
            filters[f] != undefined &&
            filters[f] != null &&
            filters[f] != ""
        )
        .map((k) => {
          return {
            label: k,
            value: filters[k],
          };
        })
    : [];

  if (!items.length) return null;

  return (
    <div className="filter-display">
      {items.map((item) => (
        <div
          className="filter-display-item"
          key={item.label}
          title={FormatDisplay(item)}
        >
          {FormatDisplay(item)}
        </div>
      ))}
      <ClearLabel onClick={resetFilters} />
    </div>
  );
};

export default JobsFilterDisplay;
